package com.patronat.top.client.presentation.auth

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.atoms.inputs.InputState
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppInputMode
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.MineShaft600
import com.patronat.top.ui.theme.Primary600
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.auth_already_have_account
import top.clientapp.generated.resources.auth_email_label
import top.clientapp.generated.resources.auth_email_placeholder
import top.clientapp.generated.resources.auth_first_name_label
import top.clientapp.generated.resources.auth_first_name_placeholder
import top.clientapp.generated.resources.auth_last_name_label
import top.clientapp.generated.resources.auth_last_name_placeholder
import top.clientapp.generated.resources.auth_login_action
import top.clientapp.generated.resources.auth_phone_label
import top.clientapp.generated.resources.auth_phone_placeholder
import top.clientapp.generated.resources.auth_register_action
import top.clientapp.generated.resources.auth_register_subtitle
import top.clientapp.generated.resources.auth_register_title

@Composable
internal fun ClientRegistrationContent(
    state: ClientAuthViewState,
    onEvent: (ClientAuthEvent) -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .widthIn(max = 420.dp)
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Spacer(modifier = Modifier.height(18.dp))

            ClientAuthBackHeader(
                title = stringResource(Res.string.auth_register_title),
                onBackClick = { onEvent(ClientAuthEvent.OnBackClicked) }
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(
                text = stringResource(Res.string.auth_register_subtitle),
                style = BodyLarge.copy(
                    color = MineShaft600,
                    textAlign = TextAlign.Center
                )
            )

            Spacer(modifier = Modifier.height(28.dp))

            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(18.dp)
            ) {
                AppInput(
                    value = state.firstName,
                    onValueChange = { onEvent(ClientAuthEvent.OnFirstNameChanged(it)) },
                    label = stringResource(Res.string.auth_first_name_label),
                    placeholder = stringResource(Res.string.auth_first_name_placeholder),
                    leadingIcon = AppIcons.Profile,
                    hint = state.firstNameError?.asString(),
                    forceState = if (state.firstNameError != null) InputState.Error else null
                )

                AppInput(
                    value = state.lastName,
                    onValueChange = { onEvent(ClientAuthEvent.OnLastNameChanged(it)) },
                    label = stringResource(Res.string.auth_last_name_label),
                    placeholder = stringResource(Res.string.auth_last_name_placeholder),
                    leadingIcon = AppIcons.Profile,
                    hint = state.lastNameError?.asString(),
                    forceState = if (state.lastNameError != null) InputState.Error else null
                )

                AppInput(
                    value = state.phone,
                    onValueChange = { onEvent(ClientAuthEvent.OnPhoneChanged(it)) },
                    label = stringResource(Res.string.auth_phone_label),
                    placeholder = stringResource(Res.string.auth_phone_placeholder),
                    hint = state.phoneError?.asString(),
                    forceState = if (state.phoneError != null) InputState.Error else null,
                    inputMode = AppInputMode.Phone
                )

                AppInput(
                    value = state.email,
                    onValueChange = { onEvent(ClientAuthEvent.OnEmailChanged(it)) },
                    label = stringResource(Res.string.auth_email_label),
                    placeholder = stringResource(Res.string.auth_email_placeholder),
                    leadingIcon = AppIcons.Email,
                    hint = state.emailError?.asString(),
                    forceState = if (state.emailError != null) InputState.Error else null,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Email)
                )
            }

            Spacer(modifier = Modifier.height(24.dp))
        }

        Spacer(modifier = Modifier.height(18.dp))

        AppButton(
            text = stringResource(Res.string.auth_register_action),
            onClick = { onEvent(ClientAuthEvent.OnSubmitRegistration) },
            modifier = Modifier.fillMaxWidth(),
            type = ButtonType.Black,
            isLoading = state.isLoading
        )

        Spacer(modifier = Modifier.height(14.dp))

        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            Text(
                text = stringResource(Res.string.auth_already_have_account),
                style = BodyLarge.copy(color = MineShaft600)
            )

            TextButton(onClick = { onEvent(ClientAuthEvent.OnLoginByPhoneClicked) }) {
                Text(
                    text = stringResource(Res.string.auth_login_action),
                    style = BodyLarge.copy(
                        color = Primary600,
                        fontWeight = FontWeight.SemiBold
                    )
                )
            }
        }

        Spacer(modifier = Modifier.height(30.dp))
    }
}
